import { configureStore } from '@reduxjs/toolkit';
import filtersSlice from './filters/filters.slice';
import tipFiltersslice from './filters/tipFilters.slice';

export const store = configureStore({
  reducer: {
    filters: filtersSlice.reducer,
    tipFilters: tipFiltersslice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
